import { useEffect, useState } from 'react'
import { INFTMetadata } from 'src/types'

export const useArweaveMetadata = (arweaveURL: string | null) => {
  const [data, setData] = useState<null | INFTMetadata>(null)

  useEffect(() => {
    if (!arweaveURL) {
      return
    }

    fetch(arweaveURL)
      .then((response) => response.json())
      .then(setData)
      .catch()
  }, [arweaveURL])

  return data
}
